import { render, staticRenderFns } from "./BenefitType.vue?vue&type=template&id=13205c5c&scoped=true"
import script from "./BenefitType.vue?vue&type=script&lang=js"
export * from "./BenefitType.vue?vue&type=script&lang=js"
import style0 from "./BenefitType.vue?vue&type=style&index=0&id=13205c5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13205c5c",
  null
  
)

export default component.exports